import PublicClient from "./public";

export default class AuthenticatedClient extends PublicClient {
  getIndex(path, params, callback) {
    const uriParams = this.paramsToURI(params);
    return this.get([path, uriParams], callback);
  }
  
  getConfig(callback) {
    var CONFIG_PATH = "api/v3/me";

    return this.get([CONFIG_PATH], callback);
  }
  getConfigByApiKey(apiKey,callback) {
    var CONFIG_PATH = `api/v3/me?api_key=${apiKey}`;

    return this.get([CONFIG_PATH], callback);
  }

  getVisualization(vizUrl, params, callback) {
    const VIZ_API_PATH = "api/v1/viz";
    const uriParams = this.paramsToURI(params);

    return this.get([VIZ_API_PATH, vizUrl, uriParams], callback);
  }

  //获取地图图层
  getMapLayers(mapId, callback) {
    const MAP_LAYERS_PATH = `api/v1/maps/${mapId}/layers`;
    return this.get([MAP_LAYERS_PATH], callback);
  }

  getMap(mapId, callback) {
    const MAPS_API_PATH = "api/v1/maps";

    return this.get([MAPS_API_PATH, mapId], callback);
  }

  getMeConfig(callback) {
    var CONFIG_PATH = `api/v3/me`;

    return this.get([CONFIG_PATH], callback);
  }
}
